module.exports = __webpack_public_path__ + "static/img/SOS_gray.160745d8.png";